import { VRow, VCardTitle } from "vuetify/lib";

export default {
	name: "ReportHeader",

	render() {
		return <VCardTitle class="primary white--text pa-3">
			<VRow align="center" noGutters>
				{this.$slots.default}
			</VRow>
		</VCardTitle>;
	}
};
